
const state =  {
  menuList: {}
}

const mutations = {
  menuListChange(state, menu) {
    state.menuList = menu
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
